import { useState } from "react";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import CustomerMaterialDialog from "../dialogTypes/CustomerMaterialDialog";

function CustomerMaterialButton(props) {
	const {
		id,
		grid,
		refresh,
		schema,
		createButtonName,
		onSuccess,
		customizeErrorMsgCallback,
		...others
	} = props;
	const [open, setOpen] = useState(false);

	const onOpen = () => {
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
	};

	const onShipSuccess = (msg) => {
		if (onSuccess) {
			onSuccess(msg);
		}

		if (refresh) {
			refresh.refresh();
		}
	};

	return (
		<>
			<CreateRecordButtonLayout
				id={id + "create-button"}
				onClick={onOpen}
				createButtonName={createButtonName}
				{...others}
			/>
			<CustomerMaterialDialog
				id={id + "customer-material-dialog"}
				schema={schema}
				open={open}
				onClose={onClose}
				onSuccess={onShipSuccess}
			/>
		</>
	);
}

export default CustomerMaterialButton;
